function HtmlHeader() {
    return (
        <header className="header">
            <h1>CINEFLEX</h1>
        </header>
    )
}

export default function Header() {
    return (
        <HtmlHeader />
    )
}